import BASE from './base'

let bindEl = null;
window.pageloading = []

let bindUpload = (callBack,params) => {
  return new Promise((resolve, reject) => {
    let uploader = null
    uploader = new plupload.Uploader({
      runtimes: 'html5,flash,silverlight,html4',
      browse_button: bindEl,
      //multi_selection: false,
      flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
      silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
      url: 'http://oss.aliyuncs.com',

      filters: {
        mime_types: [ //只允许上传图片和zip,rar文件
          {title: "Image files", extensions: "jpg,gif,png,bmp"},
          {title: "Zip files", extensions: "zip,rar"}
        ],
        max_file_size: '10mb', //最大只能上传10mb的文件
        prevent_duplicates: true //不允许选取重复文件
      },

      init: {
        PostInit: function () {
          window.pageloading.push(uploader)
        },

        FilesAdded: function (up, files) {
          BASE.set_upload_param(uploader, '', false);
        },

        BeforeUpload: function (up, file) {
          BASE.check_object_radio();
          BASE.set_upload_param(up, file.name, true);
        },

        UploadProgress: function (up, file) {
          // console.log(file);
        },

        FileUploaded: function (up, file, info) {
          if (info.status !== 200) {
            let state = {
              code: '-200',
              msg: info.message
            }
            callBack.error(state)
          } else {
            let file_name = BASE.get_uploaded_object_name(file.name);
            let filePath = requestBody.data.host + '/' + file_name;
            callBack.success({filePath, up, file, info},params)
          }
        },
        Error: function (up, err) {
          if(callBack.error){
            callBack.error(err)
          }
        }
      }
    });
    uploader.init();
  })
};

let requestBody = null;
export default {
  bind(el, binding){
    bindEl = el;
    let callBack = binding.value.callBack;
    let params = binding.value.params;

    if (callBack.success == null) {
      console.log('-----注册上传组件需定义 callBack.success 回调函数-----');
      return false;
    }

    if(requestBody == null){
      let body = BASE.send_request();
      requestBody = eval("(" + body + ")");
    }
    bindUpload(callBack,params)
   /* bindUpload(callBack).then((rsp) => {
      console.log(123)
      callBack.success(rsp, params)
    }).catch((rsp) => {
      console.log(rsp)
      // if (callBack.error != null) {
      //   callBack.error(rsp, params)
      // }
    });*/
  }
}



// WEBPACK FOOTER //
// ./src/common/libs/vue-upload/vue-upload.js